import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';
import {EncryptionService} from "./encryption.service";

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(public router: Router, private encryptionService: EncryptionService) {
    }

    canActivate(): boolean {
        const pTokenData = this.encryptionService.getDataFromLocalStorage('NPToken');
        if (pTokenData) {
            return true;
        } else {
            this.router.navigate(['']);
            return false;
        }
    }
}
